var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaret(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.86527 0.702148C1.66752 0.702191 1.47422 0.760862 1.30981 0.870747C1.1454 0.980631 1.01726 1.13679 0.941588 1.31949C0.865918 1.50219 0.846114 1.70323 0.884682 1.89718C0.923249 2.09113 1.01846 2.2693 1.15827 2.40915L7.15827 8.40915C7.34579 8.59662 7.6001 8.70193 7.86527 8.70193C8.13043 8.70193 8.38474 8.59662 8.57227 8.40915L14.5723 2.40915C14.7121 2.2693 14.8073 2.09113 14.8458 1.89718C14.8844 1.70323 14.8646 1.50219 14.7889 1.31949C14.7133 1.13679 14.5851 0.980631 14.4207 0.870747C14.2563 0.760862 14.063 0.702191 13.8653 0.702148H1.86527Z",
    fill: "#313131"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaret);
export default __webpack_public_path__ + "static/media/caret.1fb4b9f8682ce9499beeef9c91dbba93.svg";
export { ForwardRef as ReactComponent };